import "./css/AboutUs.css";
import "./css/Complaints.css";
import React from "react";
import { FaAddressBook } from "react-icons/fa";

const InformationOfficers = () => {
  return (
    <div className="about-us">
      {/* === Header Section === */}
      <section className="about-header testing-header">
        <div className="overlay">
          <h1 className="page-title">Information Officers</h1>
          <p className="subtitle">
            Designation of Information Officers for the Malawi Bureau of Standards (MBS)
          </p>
        </div>
      </section>

      {/* === Information Officers Intro Section === */}
      <section className="complaints-section">
       
          <p>
            In compliance with the <strong>Access to Information Act (ATIA) 2017</strong>,
            the Malawi Bureau of Standards (MBS) has designated the following
            as Information Officers responsible for handling all requests made under
            <strong> Section 18 of the ATIA</strong>.
          </p>
        
      </section>

      {/* === Officers Details Section === */}
      <section className="how-it-works">
        <h2>Designated Information Officers</h2>

        <div className="steps-container">
          {/* Officer 1 */}
          <div className="step-card">
            <div className="icon-circle">
              <FaAddressBook className="info-icon" />
            </div>
            <h3>CA. Bright Dzoole</h3>
            <p><strong>Designation:</strong> Director of Finance</p>
            <p><strong>Address:</strong> P.O. Box 946, Blantyre</p>
            <p><strong>Email:</strong> brightdzoole@mbsmw.org</p>
            <p><strong>Tel:</strong> 0999 869 831</p>
            <p className="physical-address">
              <strong>Physical Address:</strong><br />
              Muyeso House<br />
              Ali Hassan Mwinyi Road, Blantyre<br />
              Room No. 309
            </p>
          </div>

          {/* Officer 2 */}
          <div className="step-card">
            <div className="icon-circle">
              <FaAddressBook className="info-icon" />
            </div>
            <h3>Mrs Elizabeth Kunje</h3>
            <p><strong>Designation:</strong> Deputy Director of Standards Development</p>
            <p><strong>Address:</strong> P.O. Box 946, Blantyre</p>
            <p><strong>Email:</strong> elizabethkunje@mbsmw.org</p>
            <p><strong>Tel:</strong> 0888 894 418</p>
            <p className="physical-address">
              <strong>Physical Address:</strong><br />
              Muyeso House<br />
              Ali Hassan Mwinyi Road, Blantyre<br />
              Room No. 325
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default InformationOfficers;
